webpackJsonp([5],{

/***/ 612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_selectors__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_indexOf__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_indexOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_indexOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_omit__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_pick__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_reject__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isNil__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_find__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_map__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_map__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import SmartPageForm from './SmartPageForm';
var SmartPageForm=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, 824));});var mapStateToProps=function mapStateToProps(state){return{currentUser:Object(__WEBPACK_IMPORTED_MODULE_5__reducers_selectors__["f" /* currentUserSelector */])(state),routerPath:((state.router||{}).location||{}).pathname};};var matchDispatchToProps=function matchDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])({addLinkSuccess:__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* addLinkSuccess */],redirectTo:__WEBPACK_IMPORTED_MODULE_3__actions__["D" /* redirectTo */]},dispatch);};var NewSmartPage=function(_Component){_inherits(NewSmartPage,_Component);function NewSmartPage(props){_classCallCheck(this,NewSmartPage);var _this=_possibleConstructorReturn(this,(NewSmartPage.__proto__||Object.getPrototypeOf(NewSmartPage)).call(this,props));_this.state={initialValues:{}};return _this;}_createClass(NewSmartPage,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,currentUser=_props.currentUser,routerPath=_props.routerPath,redirectTo=_props.redirectTo;var queryparams=__WEBPACK_IMPORTED_MODULE_6_query_string___default.a.parse((this.props.location||{}).search)||{};var _ref=__WEBPACK_IMPORTED_MODULE_6_query_string___default.a.parse((this.props.location||{}).search)||{},slug=_ref.slug,ref=_ref.ref,fte=_ref.fte;var initialValues=this.prepareInitialValues(this.props.initialValues||{settings:{}});this.setState({initialValues:Object.assign({slug:slug,ref:ref},initialValues,{settings:initialValues&&initialValues.settings||{type:'smartpage'}}),showFTE:!!fte});if((currentUser||localStorage.getItem('smartpageFteDone')==='1'||localStorage.getItem('jwtToken'))&&((routerPath||'').replace(/\//gi,'')==='bio'||__WEBPACK_IMPORTED_MODULE_8_lodash_indexOf___default()(__WEBPACK_IMPORTED_MODULE_7_lodash_keys___default()(queryparams),"lp")>=0)){redirectTo('/');}}},{key:'onSuccess',value:function onSuccess(res){var _props2=this.props,addLinkSuccess=_props2.addLinkSuccess,onSuccess=_props2.onSuccess;addLinkSuccess(res);if(onSuccess&&typeof onSuccess==='function')onSuccess(res);}},{key:'enrichSublinksList',value:function enrichSublinksList(sublinks,list){var merge=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var fn=arguments[3];return __WEBPACK_IMPORTED_MODULE_11_lodash_reject___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_map___default()(list,function(ln){var l=__WEBPACK_IMPORTED_MODULE_9_lodash_omit___default()(ln,['visible']);if(ln.visible===false)l.hide=true;if(!l.id)return Object.assign({},merge,l);var sublink=__WEBPACK_IMPORTED_MODULE_13_lodash_find___default()(sublinks,{id:l.id});if(!sublink)return null;return Object.assign({},merge,__WEBPACK_IMPORTED_MODULE_10_lodash_pick___default()(sublink,['url','can_change_url','meta']),l);}),__WEBPACK_IMPORTED_MODULE_12_lodash_isNil___default.a);}},{key:'prepareInitialValues',value:function prepareInitialValues(link){var sublinks=link.sublinks,_link$settings=link.settings,blocks=_link$settings.blocks,messengers=_link$settings.messengers,social_links=_link$settings.social_links,buttons=_link$settings.buttons;var settings=Object.assign({},link.settings,{type:"smartpage",blocks:this.enrichSublinksList(sublinks,blocks||buttons,{layout:'button'}),messengers:this.enrichSublinksList(sublinks,messengers),social_links:this.enrichSublinksList(sublinks,social_links)});return Object.assign({},__WEBPACK_IMPORTED_MODULE_10_lodash_pick___default()(link,['id','domain_id','slug','title','description','pixel_set_ids','tags','meta','settings','gsm_partner_key','ref','special_k','special_h']),{settings:settings});}},{key:'render',value:function render(){var _state=this.state,initialValues=_state.initialValues,showFTE=_state.showFTE;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmartPageForm,{showFTE:showFTE,initialValues:initialValues,onSubmit:__WEBPACK_IMPORTED_MODULE_4__api__["d" /* Link */].create,onSuccess:this.onSuccess.bind(this),resetOnSuccess:true});}}]);return NewSmartPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,matchDispatchToProps)(NewSmartPage));

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(127),
    baseFilter = __webpack_require__(221),
    baseIteratee = __webpack_require__(31),
    isArray = __webpack_require__(12),
    negate = __webpack_require__(684);

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

module.exports = reject;


/***/ }),

/***/ 684:
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),

/***/ 685:
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ })

});


// WEBPACK FOOTER //
// static/js/5.74d064b5.chunk.js